// document.addEventListener("click", function (event) {
//   if (
//     event.target.matches(".size_option_swatch") ||
//     event.target.closest(".size_option_swatch")
//   ) {
//     if (event.target.closest(".product-card-wrapper")) {
//       const size = event.target.matches(".size_option_swatch")
//         ? event.target
//         : event.target.closest(".size_option_swatch");
//       const parent = event.target.closest(".product-card-wrapper");
//       const ATCbtn = parent.querySelector(".atc_btn_card");
//       const sizes = parent.querySelectorAll(".size_option_swatch");
//       sizes?.forEach((btn) => btn.classList.remove("active"));
//       size.classList.add("active");
//       const id = parseInt(size.getAttribute("data-id"));
//       const BIStrigger = size
//         .closest(".product-card-wrapper")
//         ?.querySelector(".BIS_trigger");
//       const select = size
//         .closest(".product-card-wrapper")
//         ?.querySelector('.ProductForm select[name="id"]');
//       if (size.classList.contains("out_of_stock")) {
//         BIStrigger.style.display = "";
//       } else {
//         BIStrigger.style.display = "none";
//         window.updateCartDrawer(id);
//         document.querySelector("#cart-icon-bubble")?.click();
//       }
//       BIStrigger.setAttribute("data-variant-id", id);
//       select.querySelector("option[selected]")?.removeAttribute("selected");
//       select
//         .querySelector('option[value="' + id + '"]')
//         ?.setAttribute("selected", "selected");
//     } else if (event.target.closest(".mobile_size_swatch_popup")) {
//       const target = event.target.matches(".size_option_swatch")
//         ? event.target
//         : event.target.closest(".size_option_swatch");
//       const parent = event.target.closest(".mobile_size_swatch_popup");
//       const ATCbtn = parent.querySelector(".atc_btn_card");
//       const BICBTN = parent.querySelector(".BIS_trigger");
//       const sizes = parent.querySelectorAll(".size_option_swatch");
//       sizes?.forEach((btn) => btn.classList.remove("active"));
//       const id = parseInt(target.getAttribute("data-id"));
//       ATCbtn.removeAttribute("disabled");
//       ATCbtn.setAttribute("data-id", id);
//       BICBTN.setAttribute("data-variant-id", id);
//       target.classList.add("active");
//       if (target.classList.contains("out_of_stock")) {
//         ATCbtn.textContent = "Sold out";
//         ATCbtn.style.display = "none";
//         BICBTN.style.display = "";
//       } else {
//         ATCbtn.textContent = "Add To Cart";
//         ATCbtn.style.display = "";
//         BICBTN.style.display = "none";
//       }
//     }
//   }
//   if (
//     event.target.matches(".mobile__Bis") ||
//     event.target.closest(".mobile__Bis")
//   ) {
//     const parentBisTrgt = event.target.closest(".mobile_size_swatch_popup");
//     if (parentBisTrgt) {
//       parentBisTrgt.style.display = "none";
//     }
//   }

//   if (
//     event.target.matches(".quick_add_bag") ||
//     event.target.closest(".quick_add_bag")
//   ) {
//     if (event.target.closest(".card_size_swatches")) {
//       const SwatchesWrapper = event.target.closest(".card_size_swatches");
//       const target = event.target.matches(".quick_add_bag")
//         ? event.target
//         : event.target.closest(".quick_add_bag");
//       const sizes = SwatchesWrapper.querySelector(".info_size_swatces");
//       const name = target.getAttribute("data-title");
//       const color = target.getAttribute("data-color");
//       const BIS = SwatchesWrapper.querySelector(".mobile_bis");
//       window.createMobilePopup(name, color, sizes, BIS);
//     }
//   }
//   if (
//     event.target.matches(".overlay_wrapper_swatches") ||
//     event.target.closest(".close_btn_popup") ||
//     event.target.matches(".close_btn_popup")
//   ) {
//     if (event.target.closest(".mobile_size_swatch_popup")) {
//       event.target.closest(".mobile_size_swatch_popup")?.remove();
//     }
//   }
//   if (
//     event.target.matches(".atc_btn_card") ||
//     event.target.closest(".atc_btn_card")
//   ) {
//     const target = event.target.matches(".atc_btn_card")
//       ? event.target
//       : event.target.closest(".atc_btn_card");
//     const id = parseInt(target.getAttribute("data-id"));
//     target?.classList.add("loading");
//     window.updateCartDrawer(id, target);
//     document.querySelector("#cart-icon-bubble")?.click();
//   }
// });
document.addEventListener("click", function (event) {
  if (
    event.target.matches(".size_option_swatch") ||
    event.target.closest(".size_option_swatch")
  ) {
    if (event.target.closest(".product-card-wrapper")) {
      const size = event.target.matches(".size_option_swatch")
        ? event.target
        : event.target.closest(".size_option_swatch");
      const parent = event.target.closest(".product-card-wrapper");
      const ATCbtn = parent.querySelector(".atc_btn_card");
      const sizes = parent.querySelectorAll(".size_option_swatch");
      sizes?.forEach((btn) => btn.classList.remove("active"));
      size.classList.add("active");
      const id = parseInt(size.getAttribute("data-id"));
      const BIStrigger = size
        .closest(".product-card-wrapper")
        ?.querySelector(".BIS_trigger");
      const select = size
        .closest(".product-card-wrapper")
        ?.querySelector('.ProductForm select[name="id"]');
      if (size.classList.contains("out_of_stock")) {
        BIStrigger.style.display = "";
        const baseUrl = BIStrigger.getAttribute("href").split("?")[0];
        BIStrigger.setAttribute(
          "href",
          `${baseUrl}?view=stock-popup&variant=${id}`
        );
      } else {
        BIStrigger.style.display = "none";
        window.updateCartDrawer(id);
        document.querySelector("#cart-icon-bubble")?.click();
      }
      BIStrigger.setAttribute("data-variant-id", id);
      select.querySelector("option[selected]")?.removeAttribute("selected");
      select
        .querySelector('option[value="' + id + '"]')
        ?.setAttribute("selected", "selected");
    } else if (event.target.closest(".mobile_size_swatch_popup")) {
      const target = event.target.matches(".size_option_swatch")
        ? event.target
        : event.target.closest(".size_option_swatch");
      const parent = event.target.closest(".mobile_size_swatch_popup");
      const ATCbtn = parent.querySelector(".atc_btn_card");
      const BICBTN = parent.querySelector(".BIS_trigger");
      const sizes = parent.querySelectorAll(".size_option_swatch");
      sizes?.forEach((btn) => btn.classList.remove("active"));
      const id = parseInt(target.getAttribute("data-id"));
      ATCbtn.removeAttribute("disabled");
      ATCbtn.setAttribute("data-id", id);
      BICBTN.setAttribute("data-variant-id", id);
      target.classList.add("active");
      if (target.classList.contains("out_of_stock")) {
        ATCbtn.textContent = "Sold out";
        ATCbtn.style.display = "none";
        BICBTN.style.display = "";
        const baseUrl = BICBTN.getAttribute("href").split("?")[0];
        BICBTN.setAttribute(
          "href",
          `${baseUrl}?view=stock-popup&variant=${id}`
        );
      } else {
        ATCbtn.textContent = "Add To Cart";
        ATCbtn.style.display = "";
        BICBTN.style.display = "none";
      }
    }
  }
  if (
    event.target.matches(".mobile__Bis") ||
    event.target.closest(".mobile__Bis")
  ) {
    const parentBisTrgt = event.target.closest(".mobile_size_swatch_popup");
    if (parentBisTrgt) {
      parentBisTrgt.style.display = "none";
    }
  }

  if (
    event.target.matches(".quick_add_bag") ||
    event.target.closest(".quick_add_bag")
  ) {
    if (event.target.closest(".card_size_swatches")) {
      const SwatchesWrapper = event.target.closest(".card_size_swatches");
      const target = event.target.matches(".quick_add_bag")
        ? event.target
        : event.target.closest(".quick_add_bag");
      const sizes = SwatchesWrapper.querySelector(".info_size_swatces");
      const name = target.getAttribute("data-title");
      const color = target.getAttribute("data-color");
      const BIS = SwatchesWrapper.querySelector(".mobile_bis");
      window.createMobilePopup(name, color, sizes, BIS);
    }
  }
  if (
    event.target.matches(".overlay_wrapper_swatches") ||
    event.target.closest(".close_btn_popup") ||
    event.target.matches(".close_btn_popup")
  ) {
    if (event.target.closest(".mobile_size_swatch_popup")) {
      event.target.closest(".mobile_size_swatch_popup")?.remove();
    }
  }
  if (
    event.target.matches(".atc_btn_card") ||
    event.target.closest(".atc_btn_card")
  ) {
    const target = event.target.matches(".atc_btn_card")
      ? event.target
      : event.target.closest(".atc_btn_card");
    const id = parseInt(target.getAttribute("data-id"));
    target?.classList.add("loading");
    window.updateCartDrawer(id, target);
    document.querySelector("#cart-icon-bubble")?.click();
  }
});

window.updateCartDrawer = function (id, target) {
  if (id) {
    function getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };

    const sectionsToRender = [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cartIconBubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-section",
      },
    ];

    let formData = new FormData();
    formData.append("id", id);
    formData.append("quantity", 1);
    formData.append(
      "sections",
      sectionsToRender.map((section) => section.section)
    );
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.message);
          return;
        }

        const product = response.hasOwnProperty("items")
          ? response.items[0]
          : response;
        document.querySelector("cart-drawer")?.classList.remove("is-empty");
        target?.classList.remove("loading");
        document.querySelector(".mobile_size_swatch_popup")?.remove();
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          console.log("sectionElement", sectionElement);
          if (sectionElement) {
            sectionElement.innerHTML = getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  } else {
    console.log("No matching variant found.");
  }
};

window.createMobilePopup = function (name, color, sizes, BIS) {
  const html = `
    <div class="popup_wrapper_mobile_swatches">
      <div class="overlay_wrapper_swatches">&nbsp;</div>
      <div class="content_wrapper_swatches_size_mobile">
      <div class="logo_wp">
          <img src="https://cdn.shopify.com/s/files/1/0538/0485/9592/files/9841_New_logo_white_copy_1_222e2c43-df8b-4526-b90b-6d5a91b9e512.webp?v=1745582087">
        </div>
        <h4 class="products_name_wrapper">${name}</h4>
        ${color !== "" ? `<h4 class="color_name_swatch">${color}</h4>` : ""}
        ${sizes ? sizes.innerHTML : ""}
        ${
          sizes !== ""
            ? `<button class="atc_btn_card disable_btn" data-id="" disabled>Select an option</button>`
            : ""
        }
        ${BIS ? BIS.innerHTML : ""}
          <a href="javascript:void(0);" class="close_btn_popup">
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32 1.8854L30.1146 0L16 14.1146L1.8854 0L0 1.8854L14.1146 16L0 30.1146L1.8854 32L16 17.8854L30.1146 32L32 30.1146L17.8854 16L32 1.8854Z" fill="#fff"></path>
            </svg>
          </a>
      </div>
    </div>
  `;

  const popup = document.createElement("div");
  popup.classList.add("mobile_size_swatch_popup");
  popup.innerHTML = html;

  document.body.appendChild(popup);
};
//==================



let infiniteObserver = null;
let isLoadingMore = false;

/* =========================
   HELPERS
========================= */
function getTrigger() {
  return document.getElementById("infinite-scroll-trigger");
}

function getGrid() {
  return document.querySelector(".products-list-grid");
}

function getCurrentPage() {
  const trigger = getTrigger();
  return parseInt(trigger?.getAttribute("data-current-page"), 10) || 1;
}

function getTotalPages() {
  const trigger = getTrigger();
  return parseInt(trigger?.getAttribute("data-total-pages"), 10) || 1;
}

/* =========================
   CLICK HANDLERS
========================= */
document.addEventListener("click", function (event) {
  const loadMoreBtn = event.target.closest(".pgn-LoadMore");
  const loadPrevBtn = event.target.closest(".pgn-Loadprev");

  if (loadMoreBtn) {
    event.preventDefault();
    loadManually(loadMoreBtn);
    return;
  }

  if (loadPrevBtn) {
    event.preventDefault();
    const previousPage = parseInt(loadPrevBtn.getAttribute("data-current-page"), 10);
    loadPreviousProducts(previousPage, loadPrevBtn);
  }
});

/* =========================
   LOAD MORE MANUALLY
========================= */
async function loadManually(button) {
  if (!button) return;

  await loadMoreProducts();

  const trigger = getTrigger();
  button.style.display = "none";

  if (trigger) {
    trigger.style.display = "block";
    setupInfiniteScroll();
  }
}

/* =========================
   LOAD NEXT PAGE
========================= */
async function loadMoreProducts() {
  const trigger = getTrigger();
  const productsGrid = getGrid();

  if (!trigger || !productsGrid || isLoadingMore) return;

  let currentPage = getCurrentPage();
  const totalPages = getTotalPages();
  const sectionId = trigger.getAttribute("data-section-id");

  if (currentPage >= totalPages) return;

  isLoadingMore = true;
  currentPage += 1;

  trigger.setAttribute("data-current-page", String(currentPage));
  trigger.classList.add("is-loading");

  const fetchUrl = new URL(window.location.href);
  fetchUrl.searchParams.set("page", currentPage);

  if (sectionId) {
    fetchUrl.searchParams.set("section_id", sectionId);
  }

  try {
    const response = await fetch(fetchUrl.toString(), {
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error("Failed to load next page");
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const newGrid = doc.querySelector(".products-list-grid");
    const newTrigger = doc.getElementById("infinite-scroll-trigger");

    if (newGrid) {
      Array.from(newGrid.children).forEach((item) => {
        productsGrid.appendChild(item);
      });
    }

    if (newTrigger) {
      const totalPagesAttr = newTrigger.getAttribute("data-total-pages");
      if (totalPagesAttr) {
        trigger.setAttribute("data-total-pages", totalPagesAttr);
      }
    }

    const browserUrl = new URL(window.location.href);
    browserUrl.searchParams.set("page", currentPage);
    window.history.replaceState({ page: currentPage }, "", browserUrl.toString());
  } catch (error) {
    console.error("Failed to load more products:", error);
  } finally {
    trigger.classList.remove("is-loading");
    isLoadingMore = false;
  }
}

/* =========================
   LOAD PREVIOUS PAGE
========================= */
async function loadPreviousProducts(previousPage, trigger) {
  if (!trigger || !previousPage || previousPage < 1 || isLoadingMore) return;

  const productsGrid = getGrid();
  if (!productsGrid) return;

  const sectionId = trigger.getAttribute("data-section-id");

  trigger.classList.add("is-loading");
  isLoadingMore = true;

  const fetchUrl = new URL(window.location.href);
  fetchUrl.searchParams.set("page", previousPage);

  if (sectionId) {
    fetchUrl.searchParams.set("section_id", sectionId);
  }

  try {
    const response = await fetch(fetchUrl.toString(), {
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error("Failed to load previous page");
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const newGrid = doc.querySelector(".products-list-grid");

    if (newGrid) {
      Array.from(newGrid.children)
        .reverse()
        .forEach((item) => {
          productsGrid.insertBefore(item, productsGrid.firstChild);
        });
    }

    trigger.setAttribute("data-current-page", String(previousPage - 1));

    if (previousPage <= 1) {
      trigger.style.display = "none";
    }

    const browserUrl = new URL(window.location.href);
    browserUrl.searchParams.set("page", previousPage);
    window.history.replaceState({ page: previousPage }, "", browserUrl.toString());
  } catch (error) {
    console.error("Failed to load previous products:", error);
  } finally {
    trigger.classList.remove("is-loading");
    isLoadingMore = false;
  }
}

/* =========================
   INFINITE SCROLL
========================= */
function setupInfiniteScroll() {
  const trigger = getTrigger();
  if (!trigger) return;

  if (infiniteObserver) {
    infiniteObserver.disconnect();
  }

  infiniteObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    },
    { threshold: 0.2 }
  );

  infiniteObserver.observe(trigger);
}

/* =========================
   PAGE LIFECYCLE
========================= */
document.addEventListener("DOMContentLoaded", function () {
  setupInfiniteScroll();
});



(function () {
  if (!document.body.classList.contains("collection")) return;

  const STORAGE_KEY = "last_clicked_collection_product";

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, "");
    } catch (e) {
      return String(url || "").replace(/\/+$/, "");
    }
  }

  /* =========================
     SAVE CLICKED PRODUCT
  ========================= */
  document.addEventListener("click", function (e) {
    const link = e.target.closest("#product-grid li.grid__item a[href*='/products/']");
    if (!link) return;

    localStorage.setItem(STORAGE_KEY, normalizeUrl(link.getAttribute("href")));
  });

  /* =========================
     RESTORE SCROLL (INSTANT)
  ========================= */
  function restoreToProduct() {
    const savedUrl = localStorage.getItem(STORAGE_KEY);
    if (!savedUrl) return;

    const items = document.querySelectorAll("#product-grid li.grid__item");
    let targetItem = null;

    items.forEach(function (li) {
      const link = li.querySelector("a[href*='/products/']");
      if (!link) return;

      if (normalizeUrl(link.getAttribute("href")) === savedUrl) {
        targetItem = li;
      }
    });

    if (!targetItem) {
      console.warn("Saved product not found:", savedUrl);
      return;
    }

    const rect = targetItem.getBoundingClientRect();
    const y =
      window.pageYOffset +
      rect.top -
      window.innerHeight * 0.2;

    /* ===== FORCE INSTANT JUMP (NO SMOOTH) ===== */
    const html = document.documentElement;
    const body = document.body;

    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body.style.scrollBehavior;

    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";

    window.scrollTo(0, Math.max(0, y));

    // restore previous styles
    html.style.scrollBehavior = prevHtmlBehavior;
    body.style.scrollBehavior = prevBodyBehavior;

    localStorage.removeItem(STORAGE_KEY);
  }

  /* =========================
     TRIGGER RESTORE
  ========================= */
  window.addEventListener("pageshow", function () {
    setTimeout(restoreToProduct, 100);
  });

})();